/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */
import $ from 'jquery';
import _ from "underscore";
import request from "js-sdk/src/common/transport/request";
import ReportModel from 'bi-report/src/bi/report/model/ReportModel';
import ReportExecutionModel from 'bi-report/src/bi/report/model/ReportExecutionModel';
import createReportModelMixin from "./factory/reportModelMixinFactory";
import CanvasView from '../dashboard/view/base/CanvasView';


var DashboardReportNavigation =  {
    dashboardReportsId: [],
    addDashboardReport(id) {
        this.dashboardReportsId.push(id);
    },
    confirmAndLeave(option) {
        return  (exitCallback) => {
            var promises = [];
            _.each(DashboardReportNavigation.dashboardReportsId, (url) => {
                promises.push(request({
                    url: url,
                    type: 'DELETE'
                }));
            });
            $.when(...promises)
                .done(() => {
                    if (typeof exitCallback == 'function') {
                        DashboardReportNavigation.dashboardReportsId = [];
                        exitCallback();
                    }
                });
            if(option === "logOut"){
                _.extend(CanvasView.prototype, {
                    removeAllComponentViews() {}
                });
            }
        };
    },
};

const ReportModelExecute = ReportModel.prototype.execute;
let reportModelMixin = createReportModelMixin(ReportModelExecute,DashboardReportNavigation);
let reportExecModelMixin = {
    remove() {}
};
_.extend(ReportModel.prototype, reportModelMixin);
_.extend(ReportExecutionModel.prototype, reportExecModelMixin);

export default DashboardReportNavigation;